import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import FilterComponent from '@/components/common/FilterComponent';
import MainHeading from '@/components/common/MainHeading';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
import useFilter from '@/hooks/useFilter';
import { IPageInfo } from '@/interfaces/common.model';
import { RootState } from '@/redux/store';
import {
  formatISTTime,
  getFilterUrl,
  orderByList,
  showToastNotification,
} from '@/utility/helper';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  IAttendanceLogResponse,
  IAttendanceLogState,
  IAttLogTableData,
} from '@/interfaces/attendance.model';
interface IAttendanceLogPagination extends IPageInfo {
  count: number;
  searchQuery: string;
}

const AttendanceLogs = () => {
  const location = useLocation();
  const date = location?.state?.attendanceDate;
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const [state, setState] = useState<IAttendanceLogState>({
    AttendanceLogs: [],
    tableLoader: false,
  });
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const [pagination, setPagination] = useState<IAttendanceLogPagination>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    pageSize: 10,
    searchQuery: '',
  });

  const tableHeading: ITableColumn<IAttLogTableData>[] = [
    { value: 'index', label: '#' },
    { value: 'inTime', label: 'In time' },
    { value: 'outTime', label: 'Out time' },
  ];
  useEffect(() => {
    getAttendanceLog();
  }, [
    filterDetails?.currentPage,
    pagination?.pageSize,
    filterDetails?.orderBy,
    pagination?.searchQuery,
  ]);

  const getAttendanceLog = async () => {
    try {
      setState((prev) => ({
        ...prev,
        tableLoader: true,
      }));
      const filter = {
        employeeCode: location?.state?.employeeCode
          ? location?.state?.employeeCode
          : userDetails?.employeeCode,
        attendanceDate: moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        search: pagination?.searchQuery,
        orderBy: filterDetails?.orderBy,
        pageSize: filterDetails?.pageSize,
        currentPage: filterDetails?.currentPage,
      };
      const API =
        API_URL + API_ENDPOINT?.getAttendanceLog + '?' + getFilterUrl(filter);
      const response: IAttendanceLogResponse = await callApi(API, {
        method: 'GET',
      });
      setState((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const punches = [...response.data].sort(
          (a, b) =>
            new Date(a.punchTime).getTime() - new Date(b.punchTime).getTime(),
        );

        const pairedLogs: IAttLogTableData[] = [];

        for (let i = 0; i < punches.length; i += 2) {
          const inPunch = punches[i];
          const outPunch = punches[i + 1];

          pairedLogs.push({
            index: pairedLogs.length + 1,
            id: inPunch._id,
            inTime: formatISTTime(inPunch.punchTime),
            outTime: outPunch ? formatISTTime(outPunch.punchTime) : '--',
          });
        }

        setState((prev) => ({
          ...prev,
          AttendanceLogs: pairedLogs,
        }));
      } else {
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setState((prev) => ({
        ...prev,
        tableLoader: false,
      }));
    }
  };

  const { orderByHandler } = useFilter(pagination, setPagination);

  return (
    <Layout>
      <div className="content">
        <MainHeading
          title={`${location?.state?.name ? location?.state?.name : ''} Attendance logs`}
          showbBackButton
        />
        <CardLayout cardStyle=" mb-4">
          <FilterComponent
            searchPlaceHolder="Search"
            orderByList={orderByList}
            orderByHandler={orderByHandler}
            // handleSearch={handleSearchChange}
            isGrid={false}
          />
          <CommonTable
            tableData={state?.AttendanceLogs}
            tableHeading={tableHeading}
            pageSize={pagination?.pageSize ?? 0}
            isLoading={state?.tableLoader}
            count={pagination?.count}
            totalPages={pagination?.totalPages}
            currentPage={pagination?.currentPage}
          />
        </CardLayout>
      </div>
    </Layout>
  );
};

export default AttendanceLogs;
